import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import Logo1 from '../../assets/icons/logo1.svg';
import Logo2 from '../../assets/icons/logo2.svg';
import ArrowUp from '../../assets/icons/arrowUp.svg';
import TgIcon from '../../assets/icons/tg.svg';
import { languageAtom } from '../../atoms/globalAtoms';
import useComponentVisible from '../../hooks/UseComponentVisible';
import LocalStorageServices from '../../services/LocalStorageServices';
import useTranslations from '../../hooks/useTranslations';
import { DICTIONARY } from '../../translations/dictionary';

function Footer() {
  const { t } = useTranslations();
  return (
    <div className={styles.footer}>
      <a href="/">{t(DICTIONARY.topAuctions)}</a>
      <a href="/about">{t(DICTIONARY.about)}</a>
      <a href="/terms">{t(DICTIONARY.terms)}</a>
      <a href="/privacy">{t(DICTIONARY.privacy)}</a>
    </div>
  );
}

export default Footer;
